import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import { WebPageSchema, BreadcrumbListSchema, FAQPageSchema, OrganizationSchema } from '@/components/base/SchemaOrg';
import { brandInfo, reviews, faqs } from '@/mocks/about';

export default function About() {
  return (
    <>
      <ScrollToTop />
      <OrganizationSchema />
      <WebPageSchema
        title="关于我们 - 黄瓜影视在线看"
        description="了解黄瓜影视品牌故事、发展历程、用户口碑与联系方式。黄瓜影视致力于为广大影视爱好者提供免费高清影视在线观看服务。"
        url="https://huanggua.tv/about"
      />
      <BreadcrumbListSchema
        items={[
          { name: '首页', url: 'https://huanggua.tv' },
          { name: '关于我们', url: 'https://huanggua.tv/about' },
        ]}
      />
      <FAQPageSchema questions={faqs} />

      <div className="min-h-screen" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
        <Navbar />

        <main className="pt-20 pb-12">
          <div className="w-full px-4 md:px-6 lg:px-8">
            <nav className="flex items-center gap-2 text-sm mb-6 flex-wrap" aria-label="面包屑导航">
              <Link to="/" className="hover:text-primary-500 transition-colors" style={{ color: 'oklch(var(--foreground-400))' }}>首页</Link>
              <span style={{ color: 'oklch(var(--foreground-300))' }}>/</span>
              <span style={{ color: 'oklch(var(--foreground-700))' }}>关于我们</span>
            </nav>

            <section className="mb-14 md:mb-18">
              <div className="text-center mb-10">
                <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
                  <i className="ri-movie-2-fill text-3xl" style={{ color: 'oklch(var(--background-50))' }}></i>
                </div>
                <h1 className="text-3xl md:text-4xl font-bold font-heading mb-3" style={{ color: 'oklch(var(--foreground-950))' }}>
                  {brandInfo.name}
                </h1>
                <p className="text-base max-w-2xl mx-auto" style={{ color: 'oklch(var(--foreground-500))' }}>
                  {brandInfo.slogan}
                </p>
              </div>

              <div className="max-w-4xl mx-auto">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-6 mb-12">
                  {brandInfo.stats.map(stat => (
                    <div
                      key={stat.label}
                      className="text-center p-5 md:p-6 rounded-2xl animate-fade-in-up"
                      style={{ backgroundColor: 'oklch(var(--background-100))' }}
                    >
                      <div className="text-2xl md:text-3xl font-bold font-heading mb-1" style={{ color: 'oklch(var(--primary-500))' }}>
                        {stat.value}
                      </div>
                      <div className="text-xs md:text-sm" style={{ color: 'oklch(var(--foreground-400))' }}>
                        {stat.label}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="space-y-6">
                  <article className="p-6 md:p-8 rounded-2xl" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
                    <h2 className="text-xl font-bold font-heading mb-4 flex items-center gap-2" style={{ color: 'oklch(var(--foreground-900))' }}>
                      <i className="ri-building-2-line text-primary-500"></i>
                      品牌介绍
                    </h2>
                    <p className="text-sm leading-relaxed mb-4" style={{ color: 'oklch(var(--foreground-500))' }}>
                      {brandInfo.description}
                    </p>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                      <div className="p-4 rounded-xl" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
                        <h4 className="text-sm font-semibold mb-2" style={{ color: 'oklch(var(--foreground-700))' }}>我们的使命</h4>
                        <p className="text-xs" style={{ color: 'oklch(var(--foreground-400))' }}>{brandInfo.mission}</p>
                      </div>
                      <div className="p-4 rounded-xl" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
                        <h4 className="text-sm font-semibold mb-2" style={{ color: 'oklch(var(--foreground-700))' }}>我们的愿景</h4>
                        <p className="text-xs" style={{ color: 'oklch(var(--foreground-400))' }}>{brandInfo.vision}</p>
                      </div>
                      <div className="p-4 rounded-xl" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
                        <h4 className="text-sm font-semibold mb-2" style={{ color: 'oklch(var(--foreground-700))' }}>核心价值观</h4>
                        <div className="flex flex-wrap gap-1.5">
                          {brandInfo.values.map(v => (
                            <span key={v} className="px-2 py-0.5 rounded text-xs" style={{ backgroundColor: 'oklch(var(--primary-500)/0.1)', color: 'oklch(var(--primary-600))' }}>{v}</span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </article>
                </div>
              </div>
            </section>

            <section className="mb-14 md:mb-18 max-w-4xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-2xl md:text-3xl font-bold font-heading mb-2" style={{ color: 'oklch(var(--foreground-950))' }}>
                  用户口碑
                </h2>
                <p className="text-sm" style={{ color: 'oklch(var(--foreground-400))' }}>
                  来自真实用户的评价
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
                {reviews.map((review, idx) => (
                  <article
                    key={idx}
                    className="p-5 rounded-2xl animate-fade-in-up"
                    style={{ backgroundColor: 'oklch(var(--background-100))', animationDelay: `${idx * 100}ms` }}
                  >
                    <div className="flex items-center gap-3 mb-3">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-10 h-10 rounded-full object-cover object-top"
                      />
                      <div>
                        <h4 className="text-sm font-semibold" style={{ color: 'oklch(var(--foreground-800))' }}>{review.name}</h4>
                        <div className="flex items-center gap-0.5 mt-0.5">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <i
                              key={i}
                              className={`text-xs ${i < review.rating ? 'ri-star-fill' : 'ri-star-line'}`}
                              style={{ color: i < review.rating ? 'oklch(var(--accent-500))' : 'oklch(var(--foreground-200))' }}
                            ></i>
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-sm leading-relaxed mb-2" style={{ color: 'oklch(var(--foreground-500))' }}>
                      {review.content}
                    </p>
                    <time className="text-xs" style={{ color: 'oklch(var(--foreground-300))' }}>{review.date}</time>
                  </article>
                ))}
              </div>
            </section>

            <section className="mb-14 md:mb-18 max-w-4xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="text-2xl md:text-3xl font-bold font-heading mb-2" style={{ color: 'oklch(var(--foreground-950))' }}>
                  联系我们
                </h2>
                <p className="text-sm" style={{ color: 'oklch(var(--foreground-400))' }}>
                  如有任何问题，欢迎随时联系我们
                </p>
              </div>

              <article className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
                <div className="p-6 rounded-2xl" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
                  <h3 className="text-lg font-semibold font-heading mb-4" style={{ color: 'oklch(var(--foreground-800))' }}>联系方式</h3>
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'oklch(var(--primary-500)/0.1)' }}>
                        <i className="ri-map-pin-line text-lg" style={{ color: 'oklch(var(--primary-500))' }}></i>
                      </div>
                      <div>
                        <p className="text-xs" style={{ color: 'oklch(var(--foreground-400))' }}>公司地址</p>
                        <p className="text-sm font-medium" style={{ color: 'oklch(var(--foreground-700))' }}>{brandInfo.address}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'oklch(var(--accent-500)/0.1)' }}>
                        <i className="ri-mail-line text-lg" style={{ color: 'oklch(var(--accent-500))' }}></i>
                      </div>
                      <div>
                        <p className="text-xs" style={{ color: 'oklch(var(--foreground-400))' }}>电子邮箱</p>
                        <p className="text-sm font-medium" style={{ color: 'oklch(var(--foreground-700))' }}>{brandInfo.email}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'oklch(var(--secondary-500)/0.1)' }}>
                        <i className="ri-phone-line text-lg" style={{ color: 'oklch(var(--secondary-500))' }}></i>
                      </div>
                      <div>
                        <p className="text-xs" style={{ color: 'oklch(var(--foreground-400))' }}>联系电话</p>
                        <p className="text-sm font-medium" style={{ color: 'oklch(var(--foreground-700))' }}>{brandInfo.phone}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'oklch(var(--foreground-50)/0.5)' }}>
                        <i className="ri-wechat-line text-lg" style={{ color: 'oklch(var(--foreground-600))' }}></i>
                      </div>
                      <div>
                        <p className="text-xs" style={{ color: 'oklch(var(--foreground-400))' }}>微信</p>
                        <p className="text-sm font-medium" style={{ color: 'oklch(var(--foreground-700))' }}>{brandInfo.wechat}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-6 rounded-2xl" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
                  <h3 className="text-lg font-semibold font-heading mb-4" style={{ color: 'oklch(var(--foreground-800))' }}>常见问题</h3>
                  <div className="space-y-3">
                    {faqs.slice(0, 4).map((faq, idx) => (
                      <details key={idx} className="group">
                        <summary className="text-sm font-medium cursor-pointer flex items-center justify-between py-2" style={{ color: 'oklch(var(--foreground-700))' }}>
                          {faq.question}
                          <i className="ri-arrow-down-s-line text-base transition-transform group-open:rotate-180" style={{ color: 'oklch(var(--foreground-400))' }}></i>
                        </summary>
                        <p className="text-xs leading-relaxed pt-1 pb-2 pl-0" style={{ color: 'oklch(var(--foreground-400))' }}>
                          {faq.answer}
                        </p>
                      </details>
                    ))}
                  </div>
                  <p className="text-xs mt-4" style={{ color: 'oklch(var(--foreground-300))' }}>
                    营业时间：{brandInfo.businessHours}
                  </p>
                </div>
              </article>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}